import { connect } from 'react-redux';

import {
    PhraseAutoStrategyPriceInfoCell,
    PhraseAutoStrategyPriceInfoCellProps
} from '../../components/PhraseAutoStrategyPriceInfoCell/PhraseAutoStrategyPriceInfoCell';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

type OwnProps = {
    bid?: number;
};

type StateProps = TStateProps<PhraseAutoStrategyPriceInfoCellProps>;

const mapStateToProps = (state: State): StateProps => {
    const { isGridScrolling } = state.grid;

    return {
        isGridScrolling
    };
};

export const PhraseAutoStrategyPriceInfoContainer = connect<StateProps, {}, OwnProps>(mapStateToProps)(
    PhraseAutoStrategyPriceInfoCell
);
